/* src/app/page-not-found/page-not-found.component.scss */
*,
*:after,
*:before {
  box-sizing: border-box;
}
body {
  background-color: black;
  font-family: "Montserrat", sans-serif;
}
main {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100vh;
  justify-content: center;
  text-align: center;
}
h1 {
  color: whitesmoke;
  font-size: 12.5rem;
  letter-spacing: 0.1em;
  margin: 0.025em 0;
  text-shadow: 0.05em 0.05em 0 rgba(0, 0, 0, 0.25);
  white-space: nowrap;
}
@media (max-width: 30rem) {
  h1 {
    font-size: 8.5rem;
  }
}
h2 {
  color: #ccc;
  margin-bottom: 0.4em;
}
p {
  color: #ccc;
  margin-top: 0;
}
/*# sourceMappingURL=page-not-found.component.css.map */
